import script from "./paperlistnav.vue?vue&type=script&setup=true&lang=js"
export * from "./paperlistnav.vue?vue&type=script&setup=true&lang=js"

import "./paperlistnav.vue?vue&type=style&index=0&id=4962c31e&scoped=true&lang=css"

import exportComponent from "D:\\doc\\project\\kepukeyanchengguozhanshi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4962c31e"]])

export default __exports__